import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=b9b87ed6&scoped=true&"
import script from "./AppPage.vue?vue&type=script&lang=js&"
export * from "./AppPage.vue?vue&type=script&lang=js&"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=b9b87ed6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b87ed6",
  null
  
)

export default component.exports